export const snakeToSentence = (str: string): string =>
  str
    .trim()
    .replace(/_+/g, ' ')
    .toLowerCase()
    .replace(/^\w/, (c) => c.toUpperCase())
